import { createContext, PropsWithChildren, useContext } from 'react';

const SplitScreenResizeContext = createContext(false);

interface SplitScreenResizeProviderProps extends PropsWithChildren {
  isResizing: boolean;
}

export function SplitScreenResizeProvider({
  children,
  isResizing,
}: SplitScreenResizeProviderProps) {
  return (
    <SplitScreenResizeContext.Provider value={isResizing}>
      {children}
    </SplitScreenResizeContext.Provider>
  );
}

export function useSplitScreenResize() {
  return useContext(SplitScreenResizeContext);
}
